
import { active } from 'd3';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CpStudentDetails from '../cards/class-progress-report/cp-student-details/cp-student-details';
import DrilldownPerformancePullup from '../pull-up/drilldown-performance-pullup/drilldown-performance-pullup';
import GroupCompetencyReport from '../report-pages/group-competency-report/group-competency-report';

@Component({
    name: 'pdf-generator',
    components: {
        'competency-report-page': GroupCompetencyReport,
        'cp-student-details': CpStudentDetails,
        'drilldown-reports-pullup': DrilldownPerformancePullup,
    },
})
export default class PdfGenerator extends Vue {


    // ---------------------------------------------------------------------------
    // Properties

    @Prop({ default: 'competency-report-page' })
    public activeReport!: string;

    @Prop()
    public propBind: any;

    @Prop()
    public eventBind: any;

    private isPdfContent: boolean = true;

    private PdfFileName: string = this.fileName;

    private isLoading: boolean = false;

    private pdfConfigProps: any = {
        showLayout: false,
        floatLayout: true,
        enableDownload: false,
        manualPagination: true,
        previewModal: false,
        pdfFormat: 'a4',
        pdfQuality: 2,
        pdfContentWidth: '1024px',
        htmlToPdfOptions: {
            margin: 10,
            filename: this.PdfFileName,
            enableLinks: true,
            image: {
                type: 'jpeg',
            },
            html2canvas: {
                scale: 0.8,
                letterRendering: true,
                useCORS: true,
                allowTaint: true,
                logging: false,
            },
            jsPDF: {
                unit: 'mm',
                orientation: 'landscape',
            },
            pagebreak: {
                // mode: ['avoid-all', 'css', 'legacy'],
                avoid: 'div.recgrid-item',
            },
        },
    };

    private get fileName() {
        const pdfName = this.propBind && this.propBind.subSelection ? this.propBind.subSelection : 'competency-report';
        return pdfName + '-' + this.activeMonth + '-' + this.activeYear;
    }

    private get activeYear() {
        const activeYear = this.propBind && this.propBind.activeYear ? this.propBind.activeYear : '';
        return activeYear;
    }

    private get activeMonth() {
        const activeMonth = this.propBind && this.propBind.activeMonth ? this.propBind.activeMonth : '';
        return activeMonth;
    }

    // ---------------------------------------------------------------------------
    // Hooks

    // ---------------------------------------------------------------------------
    // Actions

    public async onGeneratePdf() {
        this.isPdfContent = true;
        const html2pdf = this.$refs.html2Pdf as any;
        await html2pdf.generatePdf();
    }

    private hasDownloaded() {
        this.isPdfContent = false;
        this.isLoading = false;
    }

    private beforeDownload(configObj: any) {

        this.pdfConfigProps.htmlToPdfOptions.filename = this.fileName;
        this.isPdfContent = true;
        this.isLoading = true;
        this.$emit('beforeDownload', configObj);
    }

    // ---------------------------------------------------------------------------
    // Method

}
